<template>
    <div class="location-section" v-if="locationArr != null" id="menu-link-location">
        <div class="container">
            <sectionTitle :options="[{ title : locationArr.location_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: locationArr.location_quote_img, title : locationArr.location_quote_title, desc: locationArr.location_quote_desc}]"></sectionBaner>
            <sectionDescColumn :options="[{ desc_left : locationArr.location_desc_left, desc_right: locationArr.location_desc_right}]" class="section-desc-column-location"></sectionDescColumn>
            <div class="location-map-container">
                <div class="map-img-container">
                    <div class="map-img" id="scrollMapLocation">
                        <img :src="locationArr.location_map" alt="" v-if="globalLang == ''">
                        <img :src="locationArr.location_map_kz" alt="" v-if="globalLang == 'kz/'">
                    </div>
                    <div class="map-icons map-icons-left">
                        <div class="icon-item" v-for="(item, index) in locationArr.location_icons_list.slice(0, 2)" :key="index">
                            <div class="item-img"><img :src="item.Icon" alt=""></div>
                            <div class="item-desc">
                                <strong v-html="item.title"></strong>
                                <p v-html="item.desc"></p>
                            </div>
                        </div>
                    </div>
                    <div class="map-icons map-icons-right">
                        <div class="icon-item" v-for="(item, index) in locationArr.location_icons_list.slice(2)" :key="index">
                            <div class="item-img"><img :src="item.Icon" alt=""></div>
                            <div class="item-desc">
                                <strong v-html="item.title"></strong>
                                <p v-html="item.desc"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <sectionImagesMobile :options="[{ images: locationArr.location_images_mobile}]" v-if="isMobileGlobal"></sectionImagesMobile>
                <div class="location-map-cards">
                    <div class="car-icon"><img src="https://benelux.bazis.kz/cms/media/car-icon.svg" alt=""></div>
                    <div class="card-items">
                        <div class="card" v-for="(item, index) in locationArr.location_cards" :key="index">
                            <div class="card-desc">
                                <strong>{{ item.num }}</strong>
                                <span>{{ item.minute }}</span>
                            </div>
                            <div class="card-img" :style="'background-image:url(' + item.img + ')'"></div>
                            <div class="card-adres"><p>{{ item.desc }}</p></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    import sectionDescColumn from '@/components/partials/section-desc-column.vue'
    import sectionImagesMobile from '@/components/partials/section-images-mobile.vue'
    import {mapGetters} from 'vuex'

    export default {
        name: 'location-section',
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            locationArr: 'loadLocationArr',
            isMobileGlobal: 'loadisMobileGlobal',
        }),
        components: {
            sectionTitle,
            sectionBaner,
            sectionDescColumn,
            sectionImagesMobile,
        },
        methods: {
            scrollLeftMapMobile() {
                setTimeout(() => {
                    document.getElementById('scrollMapLocation').scrollLeft += 70;
                }, 400);
            }
        },
        mounted() {
            this.$store.watch(
                (state) => state.locationArr,
                (newValue) => {
                    if (newValue) {
                        this.scrollLeftMapMobile();
                    }
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/location/location-section.scss';
    @import '@/styles/components/location/location-section-respond.scss';
</style>